<div class="container">
  <div *ngIf="distributionListClusters && distributionListClusters.length > 0; else emptyList">

    <table #distributionTable data-testid="distributionTable" class="detail-tab distributionTable">
      <thead>
        <tr>
          <th class="pl-4" style="text-align: center;">{{ 'distributionList.id' | translate }}</th>
          <th style="text-align: center;">{{ 'distributionList.cluster' | translate }}</th>
          <th style="text-align: center;">{{ 'distributionList.code' | translate }}</th>
          <th style="text-align: center;">{{ 'distributionList.startDate' | translate }}</th>
          <th style="text-align: center;">{{ 'distributionList.endDate' | translate }}</th>
          <th style="text-align: center;">{{ 'distributionList.last_update_date' | translate }}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let distribution of distributionListClusters; let i = index;">
          <td class="pl-4" style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.id }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.description }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.code }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.startDate | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.endDate | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredDistribution()">{{ distribution.lastModifyDate }}</td>
          <td>
            <div class="detail-btn-container">
          
              <div class="d-flex flex-row">
                <button data-testid-generic="distribution-details" [attr.data-testid]="'distribution-details' + distribution.id" class="btn-details" (click)="toggleMenu(distribution.id,i)">
                  <i class="pi pi-ellipsis-h margin-fit"></i>
                </button>
                <div class="dropdown-menu" *ngIf="distribution.menuActivated == true">
              
                  <button class="dropdown-item-creation" data-testid-generic="distribution-delete" [attr.data-testid]="'distribution-delete' + distribution.id" (click)="onDeleteDistribution(distribution, i)"
                    [disabled]="distribution.status == 'Published'"
                    [ngClass]="{'disabled-button': distribution.status == 'Published'}">
                    {{ 'distributionList.delete_distribution' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="create-btn-container">
    <div class="opener-btn-container">
      <button data-testid="createNewDistribution" (click)="onSearchClusterToAdd()"
        [ngClass]="{'disabled-button': onCheckEndDistribution()}" [disabled]="onCheckEndDistribution()"
        class="new-distribution-button">
        <i class="pi pi-plus"></i>{{ 'distributionList.create_new_cluster' | translate }}
      </button>
  
    <!--   <button (click)="onRefreshTable()" class="new-distribution-button"
        [ngClass]="{'disabled-button': onCheckEndDistribution()}" [disabled]="onCheckEndDistribution()">
        {{ 'distributionList.refresh_cluster_list' | translate }}
      </button> -->
    </div>
  
  
  </div>
</div>
  
 
  
  <p-dialog header="{{ 'distributionList.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true"
    [closable]="false" class="custom-dialog">
    <div>
      {{ 'distributionList.confirm_delete_distribution' | translate }} {{ distributionToDelete?.description }}?
    </div>
    <div class="custom-footer">
      <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()"
        icon="pi pi-times"></button>
      <button type="button" pButton label="{{ 'common.confirm' | translate }}"
        (click)="onDefinitiveDelete(distributionToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
    </div>
  </p-dialog>
  
  <p-dialog 
  [(visible)]="menuCreationActive" 
  [style]="{width: '90vw', height: 'auto'}" 
  [contentStyle]="{overflow: 'auto'}" 
  [width]="1500" 
  [responsive]="true"
  [header]="'distributionList.add_cluster_to_list' | translate" 
  showEffect="fade" 
  [modal]="true">
  
  <app-search-distribution-cluster 
    #searchDistributionCluster 
    data-testid="searchDistributionCluster"
    (distributionListSelected)="onDistributionListSelected($event)" 
    [searchedClusters]="searchedClusters"
    [fatherDistribution]="fatherDistribution"
    (closeClusterAdd)="onClickAnnulla_ModalListDistribuzione()"
    (closeClusterAndRefresh)="closeAddPopupAndRefresh()">
  </app-search-distribution-cluster>
  
</p-dialog>

  
  
  
  <ng-template #emptyList>
    <div class="empty-list-container d-flex justify-content-center">
      <span class="empty-list-message" style=" padding: 20px;">{{ 'distributionList.empty_cluster_list' | translate }}</span>
    </div>
  </ng-template>


// WEBPACK FOOTER //
// ./src/app/views/distribution-list/distribution-list-details-3/distribution-list-details-3.component.html